import React from 'react'
import {Result, Button} from 'antd'
import history from '../../routes/history'
import {FormattedMessage} from 'react-intl'
import {inject, observer} from 'mobx-react'

@inject('accountStore')
@observer
class NoPermission extends React.Component {

  backToHomeButton = <Button type="primary" onClick={() => history.push('/')}>返回</Button>

  render() {
    const {accountStore} = this.props
    return (
      <Result
        status="403"
        title={<FormattedMessage id={accountStore.title403}/>}
        // subTitle={<FormattedMessage id='Please add permission first.'/>}
        // extra={this.backToHomeButton}
      />
    )
  }
}

export default NoPermission
